<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Bhk6Gf/Images/cover.jpg?1685327250323" alt="This image is the cover for the book Colors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Colors
      </h1>
      <p class="bookDescription body article font2">
        <p>High school senior Neil Darrien is a budding musical theater star. He has it all—a beautiful girlfriend, a scholarship at a prestigious school, and plenty of chances to showcase his talent. But when Zane Jeffrey comes to town and immediately lands a spot in the school show choir, Neil is jealous. What Neil didn’t count on, though, is Zane’s charm and humor, and the two soon become friends.</p> <p>Melissa, Neil’s girlfriend, notices Zane monopolizing Neil and draws Neil into her church. There Neil discovers a situation he knows he needs to fix, but if he does, a deep, dark secret that could cost him his future career might come out.</p> <p>When his relationship with Melissa becomes rocky, Neil is drawn to Zane in a way that is more than friendship.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Russell J. Sanders
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8995fe94